import React from 'react';
import { Form } from 'src/components/Antd';
import Co from 'src/constrains/AdvancedFilters/Collapse';
import { ProductPurchased } from 'src/constrains/AdvancedFilters/Components';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';
const Item = Form.Item;
const _ProductPurchased = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const { rootName, form, defaultState, radioName, ...rest } = props;
  const handleOnReset = () => {
    form.setFieldsValue(defaultState);
  };
  return (
    <Item
      noStyle
      shouldUpdate={(p, c) => {
        const touched = form.isFieldTouched(rootName);
        return touched; //|| cv !== pv;
      }}>
      {(f) => {
        const { getFieldValue } = f;
        const type = getFieldValue(radioName);
        const handleOnClose = () => {
          //   form
          //     .validateFields([nameType, nameValue, nameRange])
          //     .then(() => {
          //       //console.log('没错');
          //     })
          //     .catch((r) => {
          //       handleOnReset();
          //     });
        };

        const hasData = !!type;
        const textGenerator = () => {
          if (hasData) {
            return getI18n('customerList.productPurchased.purchasedanyproduct');
          }
        };

        return (
          <Co
            header={
              <div>
                {getI18n('customerList.productPurchased.productpurchased')}
              </div>
            }
            displayText={textGenerator()}
            hasData={hasData}
            onClose={handleOnClose}
            onClear={handleOnReset}>
            <ProductPurchased {...rest} radioName={radioName} />
          </Co>
        );
      }}
    </Item>
  );
};
export default _ProductPurchased;
